import { forwardRef, ReactNode } from "react";
import SubOptionLine from "../../images/subOptionLine.svg?react";
import { Box, FormControlLabel, Typography } from "@mui/material";
import { CoreCheckbox, CoreInfoIndicator } from "../../../core";
import { ProctoringPlatforms } from "@verity/proctoring-option/types";
import { OptionBlockPlatformBadge } from "../optionBlock";

export type CheckBoxMenuSubItemProps = {
	checked: boolean;
	onChange: (checked: boolean) => void;
	label: ReactNode;
	/**If a description is not provided, tooltip will not be shown */
	description?: ReactNode;
	partiallySupportedPlatforms?: Set<keyof ProctoringPlatforms>;
};

export const CheckBoxMenuSubItem = forwardRef<HTMLDivElement, CheckBoxMenuSubItemProps>(function SwitchMenuItem(
	{ checked, onChange, label, description, partiallySupportedPlatforms },
	ref,
) {
	const handleClick = () => {
		const newIsCheckedState = !checked;
		onChange(newIsCheckedState);
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "row",
				gap: "5px",
				justifyContent: "flex-start",
				alignItems: "center",
				ml: "10px",
				mt: "5px",
				mb: "5px",
			}}
			ref={ref}
		>
			<SubOptionLine style={{ marginBottom: "3px", minWidth: "11px" }} />
			<Box
				sx={{
					display: "flex",
					flexWrap: "wrap",
					alignItems: "center",
					gap: "5px",
				}}
			>
				<FormControlLabel
					control={
						<CoreCheckbox
							onClick={handleClick}
							checked={checked}
							sx={{
								margin: "2px 3px 1px 1px", // top right bottom left
								padding: "3px",
							}}
							size="16px"
							disableFocusRipple
						/>
					}
					label={
						<Typography
							component="span"
							sx={{
								fontSize: "12px",
								fontWeight: 400,
								color: "black",
								lineHeight: 1.6,
								margin: 0,
							}}
						>
							{label}
						</Typography>
					}
					sx={{ m: 0, p: 0 }}
				/>
				{description ? <CoreInfoIndicator hint={description} size={20} /> : null}
				{Array.from(partiallySupportedPlatforms ?? []).map((platform) => (
					<OptionBlockPlatformBadge key={platform} platform={platform} />
				))}
			</Box>
		</Box>
	);
});
